module.exports = __webpack_public_path__ + "static/media/lock_white_24dp.761215da.svg";